import { OpenNewTabTargetType } from "@voltmoney/types";
import { ROUTE } from "../../routes";
import { sideBarNavigate } from "../partnerWeb_Dashboard/utils";
import { VoltWebSiteBaseLink } from "../../configs/constants";
import { navigateByUrl } from "../../platformDashboard/dashboard/utils";
import { isFromAndroidWebview } from "../../configs/utils";
export const closeMenu = async (action, _datastore, standardUtilies) => {
    const routeId = action.payload.value;
    await sideBarNavigate(standardUtilies, action);
};
export const onLogout = async (action, _datastore, { navigate }) => {
    const isFromPlatform = action.payload.isFromPlatform;
    console.warn('**** onLogout Action Triggered ****', action);
    isFromPlatform ? navigate(ROUTE.PLATFORM_LOG_OUT) : navigate(ROUTE.PARTNER_LOGOUT);
};
export const navigate = async (action, _datastore, utilities) => {
    console.warn('**** navigate Action Triggered ****', action);
    const route = action.payload.route;
    const isFromPlatform = action.payload.isFromPlatform;
    if (route === 'partner_AboutUs') {
        if (isFromAndroidWebview())
            utilities.openNewTab(`${VoltWebSiteBaseLink}/about`, OpenNewTabTargetType.self);
        else
            utilities.openNewTab(`${VoltWebSiteBaseLink}/about`, OpenNewTabTargetType.blank);
    }
    else if (route === 'partner_Faq') {
        if (isFromAndroidWebview())
            utilities.openNewTab(`${VoltWebSiteBaseLink}/contact#faq`, OpenNewTabTargetType.self);
        else
            utilities.openNewTab(`${VoltWebSiteBaseLink}/contact#faq`, OpenNewTabTargetType.blank);
    }
    else if (route === 'partner_Faq_Affiliated') {
        utilities.openNewTab(`${VoltWebSiteBaseLink}affiliate#faq_affiliate`, OpenNewTabTargetType.blank);
    }
    else {
        if (isFromPlatform) {
            await navigateByUrl(route, utilities.openNewTab);
        }
        else {
            await sideBarNavigate(utilities, action);
        }
    }
};
